export default __webpack_public_path__ + "static/media/yeopen_main.e6399658.jpg";